import { EditorView } from '@codemirror/view';

export const bearTheme = EditorView.theme({
  '&': {
    fontSize: '15px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, "Noto Sans KR", sans-serif',
    color: '#1a1a1a',
    backgroundColor: '#FFFFFF',
  },
  '.cm-content': {
    padding: '4px 0 16px',
    lineHeight: '1.7',
    caretColor: '#E16B5A',
  },
  '.cm-line': {
    padding: '1px 0',
  },
  '&.cm-focused .cm-cursor': {
    borderLeftColor: '#E16B5A',
    borderLeftWidth: '2px',
  },
  '&.cm-focused .cm-selectionBackground, .cm-selectionBackground': {
    backgroundColor: '#FCE4DE !important',
  },
  '.cm-gutters': {
    display: 'none',
  },
  '&.cm-focused': {
    outline: 'none',
  },
  '.cm-activeLine': {
    backgroundColor: 'transparent',
  },
  '.cm-activeLineGutter': {
    backgroundColor: 'transparent',
  },
});
